import {themeGetter} from 'quickstart/styled-components/system'

const getDividers = (theme: any) => {
  const th = themeGetter(theme)
  return {
    borderBottomWidth: '0',
    borderLeftWidth: '0',
    borderRightWidth: '0',
    borderTopWidth: '1px',
    borderColor: th('colors.borderColor'),
    borderStyle: 'solid',
  }
}

export default getDividers
